import React, { useEffect, useState } from 'react';
import { supabase } from '../../supabaseClient';
import '../AdminShared.css';

const emptyForm = { title: '', youtube_id: '', category: 'Performance' };

export default function VideosTab() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(emptyForm);
  const [saving, setSaving] = useState(false);

  const load = async () => {
    setLoading(true);
    const { data, error } = await supabase
      .from('videos')
      .select('*')
      .order('sort_order', { ascending: true })
      .order('created_at', { ascending: false });
    if (error) setError(error.message);
    else setItems(data);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const openNew = () => { setForm(emptyForm); setEditing('new'); };
  const openEdit = (v) => { setForm(v); setEditing(v.id); };
  const closeForm = () => { setEditing(null); setForm(emptyForm); };

  // accepts either a raw ID or a full YouTube URL and extracts the ID
  const extractYoutubeId = (input) => {
    const match = input.match(/(?:youtube\.com.*(?:\?|&)v=|youtu\.be\/)([^&\n?#]+)/);
    return match ? match[1] : input.trim();
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');

    const payload = {
      title: form.title,
      youtube_id: extractYoutubeId(form.youtube_id),
      category: form.category,
    };

    const { error } = editing === 'new'
      ? await supabase.from('videos').insert(payload)
      : await supabase.from('videos').update(payload).eq('id', editing);

    setSaving(false);
    if (error) { setError(error.message); return; }
    closeForm();
    load();
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this video?')) return;
    const { error } = await supabase.from('videos').delete().eq('id', id);
    if (error) setError(error.message);
    else load();
  };

  return (
    <div>
      <div className="tab-header">
        <h2 className="tab-title">Videos</h2>
        {!editing && <button className="tab-add-btn" onClick={openNew}>+ Add video</button>}
      </div>

      {error && <p className="tab-error">{error}</p>}

      {editing && (
        <form className="admin-form" onSubmit={handleSave}>
          <div className="admin-form-row">
            <label className="admin-form-label">Title</label>
            <input
              className="admin-form-input" required
              value={form.title}
              onChange={(e) => setForm({ ...form, title: e.target.value })}
            />
          </div>

          <div className="admin-form-row">
            <label className="admin-form-label">YouTube URL or video ID</label>
            <input
              className="admin-form-input" required
              value={form.youtube_id}
              onChange={(e) => setForm({ ...form, youtube_id: e.target.value })}
              placeholder="https://youtube.com/watch?v=... or just the ID"
            />
          </div>

          <div className="admin-form-row">
            <label className="admin-form-label">Category</label>
            <input
              className="admin-form-input"
              value={form.category}
              onChange={(e) => setForm({ ...form, category: e.target.value })}
              placeholder="Performance, Music Video, Interview..."
            />
          </div>

          <div className="admin-form-actions">
            <button className="admin-form-save" disabled={saving} type="submit">
              {saving ? 'Saving...' : 'Save'}
            </button>
            <button className="admin-form-cancel" type="button" onClick={closeForm}>Cancel</button>
          </div>
        </form>
      )}

      {loading ? (
        <p className="tab-status">Loading...</p>
      ) : items.length === 0 ? (
        <p className="tab-status">No videos yet.</p>
      ) : (
        items.map((v) => (
          <div className="item-card" key={v.id}>
            <img
              src={`https://i.ytimg.com/vi/${v.youtube_id}/default.jpg`}
              alt={v.title}
              className="item-thumb"
            />
            <div className="item-info">
              <p className="item-title">{v.title}</p>
              <p className="item-sub">{v.category}</p>
            </div>
            <div className="item-actions">
              <button className="item-btn" onClick={() => openEdit(v)}>Edit</button>
              <button className="item-btn danger" onClick={() => handleDelete(v.id)}>Delete</button>
            </div>
          </div>
        ))
      )}
    </div>
  );
}
